import Tag from '@hilbi/web-common/components/tag';
import { useAppSelector } from '@hooks/app/redux';
import { actions } from '@store/ducks/tags-page';
import { Modal } from '@ui';
import { readableColor } from 'polished';
import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { ModalState } from 'types/tags-page';

const TagDeleteModal: React.FC = () => {
  const dispatch = useDispatch();
  const activeTag = useAppSelector((state) => state.tagsPage.activeTag);
  const deleteModalStatus = useAppSelector((state) => state.tagsPage.deleteModalStatus);
  const submitting = useAppSelector((state) => state.tagsPage.submitting);

  const { formatMessage } = useIntl();

  const handleClose = useCallback(() => {
    dispatch(actions.setActiveTag(null));
    dispatch(actions.setDeleteModalStatus(ModalState.closed));
  }, [dispatch]);

  if (!activeTag) return null;

  return (
    <Modal
      visible={deleteModalStatus === ModalState.opened}
      onClose={handleClose}
      footer={
        <Modal.Actions
          actions={[
            {
              key: 'cancel',
              label: <FormattedMessage id="form_cancel" />,
              variant: 'ghost',
              onClick: handleClose,
            },
            {
              key: 'submit',
              label: <FormattedMessage id="tags_delete_modal_submit" />,
              variant: 'danger',
              onClick: () => {
                dispatch(actions.deleteTag());
                dispatch(actions.setActiveTag(null));
              },
              loading: submitting,
            },
          ]}
        />
      }
    >
      <Modal.Title>{formatMessage({ id: 'tags_delete_modal_title' })}</Modal.Title>
      <Tag
        name={activeTag.name as string}
        backgroundColor={activeTag.color as string}
        textColor={readableColor(activeTag.color)}
      />
    </Modal>
  );
};

export default React.memo(TagDeleteModal);
